import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import {TranslateService} from "@ngx-translate/core";

/**
 * Formats a date (moment format string) in the active UI language. Impure because the
 * sidebar switches languages by assigning translate.currentLang, which emits nothing.
 */
@Pipe({
    name: 'localedate',
    standalone: false,
    pure: false
})
export class LocaleDatePipe implements PipeTransform {

  private last: {value: unknown, format: string, lang: string, result: string};

  constructor(private translate: TranslateService) {
  }

  transform(value: Date|string|moment.Moment|null, format: string): string {
    if(!value){
      return null;
    }
    const lang = this.translate.currentLang ?? this.translate.defaultLang;
    if(this.last?.value !== value || this.last.format !== format || this.last.lang !== lang){
      this.last = {value, format, lang, result: moment(value).locale(lang).format(format)};
    }
    return this.last.result;
  }

}
